var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 18.3385C14.6076 18.3385 18.3385 14.6076 18.3385 10.0052C18.3385 5.40284 14.6076 1.67188 10.0052 1.67188C5.40284 1.67188 1.67188 5.40284 1.67188 10.0052C1.67188 14.6076 5.40284 18.3385 10.0052 18.3385Z",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32812 6.67188L13.3281 10.0052L8.32812 13.3385V6.67188Z",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBlock);
export default __webpack_public_path__ + "static/media/video-block.f8c20c9fd601f3a374f98fd477fb9cfe.svg";
export { ForwardRef as ReactComponent };